export default {
  cover: {
    mobile: '/images/value/cover-valore-aggiunto.jpg',
    desktop: '/images/value/cover-valore-aggiunto.jpg'
  },
  quote: {
    gavosto: {
      author: {
        it: 'Andrea Gavosto, direttore della Fondazione Agnelli',
        en: 'Andrea Gavosto, Director of Fondazione Agnelli'
      },
      text: {
        it:
          `I timori per le perdite di apprendimento e la crescita delle disuguaglianze causate dal Covid nella scuola sono stati confermati. Un'intera generazione di studenti italiani potrebbe essere penalizzata. Serve uno sforzo straordinario di recupero: condizione necessaria è investire per migliorare la qualità dei docenti.`,
        en:
          `Our fears about learning losses and growing inequalities in schools due to Covid have been confirmed. An entire generation of Italian students could bear the brunt of this situation. We must make an extraordinary effort to recuperate: investing to improve the quality offered by teachers has become a prerequisite for recovery.`,
      },
      authorImg: '/images/quotes/GAVOSTO_Quote.png'
    },
    boschetti: {
      author: {
        it: 'Stefania Boschetti, Partner Ernst & Young',
        en: 'Stefania Boschetti, Ernst & Young Partner'
      },
      text: {
        it:
          'Il valore aggiunto generato esprime la ricchezza che la Fondazione distribuisce ogni anno ai propri stakeholder grazie alle attività svolte, frutto della capacità di valorizzare il patrimonio conferito dai soci fondatori, minimizzando i costi di gestione e di funzionamento.',
        en:
          "The generated added value is an expression of the wealth Fondazione Agnelli distributes, every year, to its stakeholders thanks to its initiatives; it stems from the ability to leverage founders' endowment, minimizing operating and management costs."
      },
      authorImg: '/images/quotes/BOSCHETTI_Quote.png'
    }
  }
};
